module.exports = __webpack_public_path__ + "img/lang-es.53dccff6.png";